import React from 'react'
import { Box, BoxProps } from '@chakra-ui/react'
import styles from 'components/HtmlContent/HtmlContent.module.css'

export function HtmlContent({ html, ...boxProps }: { html: string } & BoxProps) {
    return (
        <Box
            className={styles['markdown-body']}
            dangerouslySetInnerHTML={{ __html: html }}
            {...boxProps}
        />
    )
}
